import { render, staticRenderFns } from "./email-form.vue?vue&type=template&id=788c0525&scoped=true&"
import script from "./email-form.vue?vue&type=script&lang=ts&"
export * from "./email-form.vue?vue&type=script&lang=ts&"
import style0 from "./email-form.vue?vue&type=style&index=0&id=788c0525&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c0525",
  null
  
)

export default component.exports